import React from 'react';
import { Nav } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

function NoOrganizationsLink() {
  return (
    <div style={{ margin: '30px' }}>
      {`You do not have any organizations yet. `}
      <LinkContainer
        to={'/organizations'}
        style={{
          display: 'inline-block',
          marginLeft: '0px',
          paddingLeft: '0px',
        }}
      >
        <Nav.Link>{'Create one here.'}</Nav.Link>
      </LinkContainer>
    </div>
  );
}

export default NoOrganizationsLink;
